"use client";

import { useCallback } from "react";
import { useRouter, usePathname } from "next/navigation";
import { parseAsBoolean, useQueryState } from "nuqs";

const createProjectParser = parseAsBoolean.withDefault(false);

export function useCreateProjectModal() {
  const [open, setOpen] = useQueryState("createProject", createProjectParser);
  const router = useRouter();
  const pathname = usePathname();

  const openCreateProject = useCallback(() => {
    if (pathname === "/projects") {
      void setOpen(true);
    } else {
      router.push("/projects?createProject=true");
    }
  }, [pathname, setOpen, router]);

  const closeCreateProject = useCallback(() => {
    void setOpen(null);
  }, [setOpen]);

  return {
    createProjectOpen: open,
    setCreateProjectOpen: setOpen,
    openCreateProject,
    closeCreateProject,
  };
}
